import { GovDropdown, GovIcon } from '@gov-design-system-ce/react';
import type { DatoveSchrankyPrilohaDto } from '@gov-nx/api';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useDataBoxMessageAttachmentContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, DocumentDownloadItem } from '@gov-nx/ui/web';
import { useExtraConfigContext } from '@gov-nx/core/app';

interface DataBoxAttachmentItemProps {
	attachment: DatoveSchrankyPrilohaDto;
	disabled?: boolean;
	name?: string;
}

export const DataBoxAttachmentItem = ({
	attachment,
	disabled,
	name,
}: DataBoxAttachmentItemProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const {
		extraConfig: {
			pageRoutes: {
				databoxConfig: { isSaveToOwnDocumentsAllowed },
			},
		},
	} = useExtraConfigContext();

	const {
		isDropdownOpen,
		attachmentOperations: {
			handleSaveAttachmentToDocuments,
			handleDownloadAttachment,
		},
		loadingItems,
	} = useDataBoxMessageAttachmentContext();

	return (
		<li className="w-full [ sm:w-auto ]">
			<GovDropdown
				open={isDropdownOpen.value}
				position="right"
				color="primary"
				type="base"
				size="s"
				expandedMobile
				disabled={!!disabled}
				aria-label={name}
				className="document-download"
				label={
					<DocumentDownloadItem
						name={attachment.nazev}
						size={attachment.velikost}
						disabled={loadingItems.download || loadingItems.saveToDocuments}
						loading={loadingItems.download || loadingItems.saveToDocuments}
					/>
				}>
				<Button
					color="primary"
					type="base"
					size="s"
					isExpanded
					isDisabled={!!loadingItems.download}
					onClick={() => handleDownloadAttachment(attachment)}
					aria-label={tn('prilohy.stahnout')}
					iconEnd={
						<GovIcon
							name="download"
							type="templates"
						/>
					}>
					{tn('prilohy.stahnout')}
				</Button>
				{isSaveToOwnDocumentsAllowed && (
					<Button
						color="primary"
						type="base"
						size="s"
						isExpanded
						isDisabled={!!loadingItems.saveToDocuments}
						onClick={() => handleSaveAttachmentToDocuments(attachment)}
						aria-label={tn('prilohy.ulozit')}
						iconEnd={
							<GovIcon
								name="floppy"
								type="templates"
							/>
						}>
						{tn('prilohy.ulozit')}
					</Button>
				)}
			</GovDropdown>
		</li>
	);
};
